module.exports = __webpack_public_path__ + "static/media/IMG_8809.ffc8ce33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/vertical/IMG_8809.jpg
// module id = 112
// module chunks = 0